import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import styles from './EditBlogPostsPage.module.scss';
import DashboardTableCard from '../components/DashboardTableCard';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { BsTrash, BsEye, BsJournal, BsJournalCheck } from 'react-icons/bs';
import { alertModal, confirmModal } from '../utils/modalController';
import { Link, useNavigate } from 'react-router-dom';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';
const TrashIcon = BsTrash as React.FC<{ size?: number; color?: string }>;
const ShowIcon = BsEye as React.FC<{ size?: number; color?: string }>;
const PostedIcon = BsJournalCheck as React.FC<{ size?: number; color?: string }>;
const DraftIcon = BsJournal as React.FC<{ size?: number; color?: string }>;

const EditBlogPostsPage: React.FC = () => {
    const [posts, setPosts] = useState<BlogPostData[]>([]);
    const [loading, setLoading] = useState(true);
    const [creating, setCreating] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        fetchAuth(apiUrl + '/blog-edit/posts') // ajuste aqui seu endpoint real
            .then(async (res) => {
                if (!res.ok) {
                    const error = await res.json();
                    return Promise.reject(error.message || 'Erro ao buscar posts');
                }
                return res.json();
            })
            .then((json) => {
                setPosts(json);
            })
            .catch((err) => {
                console.error('Erro ao buscar posts:', err);
                alertModal('Erro ao buscar posts: ' + err);
                setPosts([]); // fallback
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) return <Loader />;

    return (
        <Container className="center">
            <h2 className={styles["title"]}>Consultório</h2>
            <Row className={styles["row-breadcrumb"]}>
                <Col>
                    <Breadcrumb className={styles.breadcrumb}>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/consultorio" }}>Consultório</Breadcrumb.Item>
                        <Breadcrumb.Item active>Posts</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <DashboardTableCard
                welcomeMessage={`Posts`}
                tableData={{
                    headings: ['Título', 'Ações'],
                    data: [
                        [
                            <a
                                href='#'
                                className={styles["link"]}
                                onClick={(e) => {
                                    e.preventDefault();

                                    if (creating) return;
                                    setCreating(true);

                                    fetchAuth(apiUrl + '/blog-edit/posts', {
                                        method: 'POST',
                                    })
                                        .then(async (res) => {
                                            if (!res.ok) {
                                                const error = await res.json();
                                                return Promise.reject(error.message || 'Erro ao criar post');
                                            }
                                            return res.json();
                                        })
                                        .then((json) => {
                                            navigate(`/consultorio/blog-post/${json.id}`);
                                        })
                                        .catch((err) => {
                                            console.error('Erro ao criar post:', err);
                                            alertModal('Erro ao criar post: ' + err);
                                            setCreating(false);
                                        })
                                }}
                            >
                                {creating ? 'Criando...' : 'Criar novo post'}
                            </a>
                        ],
                        ...posts.map((post) => [
                            <Link to={`/consultorio/blog-post/${post.id}`} className={styles["link"]}>
                                {post.title
                                    ? post.title
                                    : post.createdAt
                                        ? new Date(post.createdAt).toLocaleString()
                                        : 'Sem título'}
                            </Link>,
                            <div className={styles["actions"]}>
                                <a
                                    href='#'
                                    className={styles["action"]}
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        fetchAuth(apiUrl + '/blog-edit/posts/' + post.id.toString() + '/' + (post.posted ? 'unpublish' : 'publish'), {
                                            method: 'POST',
                                        })
                                            .then(async (res) => {
                                                if (!res.ok) {
                                                    const error = await res.json();
                                                    return Promise.reject(error.message || 'Erro ao criar post');
                                                }
                                                return res.json();
                                            })
                                            .then((json) => {
                                                setPosts(posts.map(p => p.id === post.id ? { ...p, posted: !p.posted } : p));
                                            })
                                            .catch((err) => {
                                                console.error(`Erro ao ${post.posted ? 'despublicar' : 'publicar'} post:`, err);
                                                alertModal(err);
                                            });
                                    }}
                                >
                                    {post.posted ? <PostedIcon size={20} /> : <DraftIcon size={20} />}
                                </a>
                                <Link to={`/consultorio/blog-post/${post.id}?mode=view`} className={styles["action"]}>
                                    <ShowIcon size={20} />
                                </Link>
                                <a
                                    href='#'
                                    className={styles["action"]}
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        if (!await confirmModal('Tem certeza que deseja excluir este post?', 'Excluir Post')) return;
                                        fetchAuth(apiUrl + '/blog-edit/posts/' + post.id.toString(), {
                                            method: 'DELETE',
                                        })
                                            .then(async (res) => {
                                                if (!res.ok) {
                                                    const error = await res.json();
                                                    return Promise.reject(error.message || 'Erro ao excluir post');
                                                }
                                                return res.json();
                                            })
                                            .then((json) => {
                                                setPosts(posts.filter(p => p.id !== post.id));
                                            })
                                            .catch((err) => {
                                                console.error('Erro ao excluir post:', err);
                                                alertModal('Erro ao excluir post: ' + err);
                                            });
                                    }}
                                >
                                    <TrashIcon size={20} />
                                </a>
                            </div>
                        ]),
                    ]

                }}
            />
        </Container>
    );
};

export default EditBlogPostsPage;
